import React, { ComponentPropsWithoutRef } from 'react';
import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText } from '@unmind/design-system';

const StyledMenuItem = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
  weight: theme.typography.fontWeights.regular,
}))`
  padding: ${rem(8)} 0;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  display: block;
`;

type DropdownMenuItemProps = {
  label: string;
  menuIsOpen?: boolean;
} & ComponentPropsWithoutRef<typeof BodyText>;

export const DropdownMenuItem = ({
  label,
  menuIsOpen,
  ...props
}: DropdownMenuItemProps) => (
  <StyledMenuItem tabIndex={menuIsOpen ? 0 : -1} {...props}>
    {label}
  </StyledMenuItem>
);
